module.exports = __webpack_public_path__ + "static/media/clubs_3.de438641.png";